/**
 * Phone number utilities
 */
import { parsePhoneNumberFromString } from 'libphonenumber-js';

/**
 * Formats phone number for storage and display
 * @param {string} phone - The phone number to format
 * @returns {string} - Formatted phone number without + prefix
 */
export const formatPhoneNumber = (phone) => {
  if (!phone || phone === '') return '';
  
  try {
    const inputPhoneNumber = phone.startsWith('+') ? phone : `+${phone}`;
    const parsedNumber = parsePhoneNumberFromString(inputPhoneNumber);
    console.log('Parsed Number:', parsedNumber);
    if (parsedNumber) {
      const countryCode = parsedNumber.countryCallingCode;
      const nationalNumber = parsedNumber.nationalNumber;
      return `${countryCode}${nationalNumber}`.replace(/\D/g, '');
    } else {
      const cleanPhone = phone.replace(/[^\d+]/g, '');
      return cleanPhone.startsWith('+') ? cleanPhone.substring(1) : cleanPhone;
    }
  } catch (error) {
    console.warn('Error parsing phone number:', error);
    const cleanPhone = phone.replace(/[^\d+]/g, '');
    return cleanPhone.startsWith('+') ? cleanPhone.substring(1) : cleanPhone;
  }
};

/**
 * Cleans phone number by removing non-numeric characters except +
 * @param {string} phone - The phone number to clean
 * @returns {string} - Cleaned phone number
 */
export const cleanPhoneNumber = (phone) => {
  if (!phone) return '';
  return phone.replace(/[^\d+]/g, '');
};

/**
 * Validates phone number using libphonenumber-js
 * @param {string} phone - The phone number to validate
 * @returns {Object} - { isValid: boolean, error: string|null }
 */
export const validatePhoneNumber = (phone) => {
  if (!phone || !phone.trim()) {
    return { isValid: false, error: "Phone Number is required" };
  }
  
  try {
    const phoneNumber = parsePhoneNumberFromString('+' + phone);
    if (!phoneNumber || !phoneNumber.isValid()) {
      return { isValid: false, error: "Invalid phone number for selected country" };
    }
    return { isValid: true, error: null };
  } catch (error) {
    return { isValid: false, error: "Invalid phone number format" };
  }
};

/**
 * Gets country code from phone number
 * @param {string} phone - The phone number
 * @returns {string|null} - Country code or null
 */
export const getCountryCode = (phone) => {
  if (!phone) return null;
  
  try {
    const phoneNumber = parsePhoneNumberFromString(phone.startsWith('+') ? phone : `+${phone}`);
    return phoneNumber ? phoneNumber.country : null;
  } catch (error) {
    return null;
  }
};

/**
 * Formats phone number for display with country code
 * @param {string} phone - The phone number
 * @returns {string} - Formatted phone number with + prefix
 */
export const formatPhoneForDisplay = (phone) => {
  if (!phone) return '';
  
  try {
    const phoneNumber = parsePhoneNumberFromString(phone.startsWith('+') ? phone : `+${phone}`);
    return phoneNumber ? phoneNumber.formatInternational() : phone;
  } catch (error) {
    return phone;
  }
};
